import {
    COLOR
} from '../../business-const/Color/Color'

import LABEL from '../../business-const/Label/Label'



const comparacaoCenariosEstudosGrupoList = [
    {
        id: 'PAR', 
        descricao: 'Parâmetros',
        bgColorGrupo: COLOR().bgComparacaoCenariosEstudosGrupo,
        bgColorItem: COLOR().bgComparacaoCenariosEstudosItem,
        bgColorItem2: COLOR().bgComparacaoCenariosEstudosItem2,
        ordem: 10,
    },
    {
        id: 'PVS', 
        descricao: 'Projetos de Vida/Sonho',
        bgColorGrupo: COLOR().bgComparacaoCenariosEstudosGrupo,
        bgColorItem: COLOR().bgComparacaoCenariosEstudosItem,
        bgColorItem2: COLOR().bgComparacaoCenariosEstudosItem2,
        ordem: 20,
    },
    {
        id: 'NAP', 
        descricao: 'Necessidades ' + LABEL.aposentadoria,
        descricaoSimulacaoFinanceira: 'Retiradas Planejadas',
        bgColorGrupo: COLOR().bgComparacaoCenariosEstudosGrupo,
        bgColorItem: COLOR().bgComparacaoCenariosEstudosItem,
        bgColorItem2: COLOR().bgComparacaoCenariosEstudosItem2,
        ordem: 30,
    },
    {
        id: 'APT', 
        descricao: 'Aportes Planejados',
        bgColorGrupo: COLOR().bgComparacaoCenariosEstudosGrupo,
        bgColorItem: COLOR().bgComparacaoCenariosEstudosItem,
        bgColorItem2: COLOR().bgComparacaoCenariosEstudosItem2,
        ordem: 40,
    },
    {
        id: 'APO', 
        descricao: LABEL.aposentadoria,
        bgColorGrupo: COLOR().bgComparacaoCenariosEstudosGrupo,
        bgColorItem: COLOR().bgComparacaoCenariosEstudosItem,
        bgColorItem2: COLOR().bgComparacaoCenariosEstudosItem2,
        ordem: 50,
    },
    {
        id: 'RIS', 
        descricao: 'Riscos',
        bgColorGrupo: COLOR().bgComparacaoCenariosEstudosGrupo,
        bgColorItem: COLOR().bgComparacaoCenariosEstudosItem,
        bgColorItem2: COLOR().bgComparacaoCenariosEstudosItem2,
        ordem: 60,
    },
]

export default comparacaoCenariosEstudosGrupoList